var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileDdImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7812 11C15.0938 11 17 12.9062 17 15.2188V16.5C17 17.3438 16.3125 18 15.5 18H4.5C3.65625 18 3 17.3438 3 16.5V15.2188C3 12.9062 4.875 11 7.1875 11C8.09375 11 8.5 11.5 10 11.5C11.4688 11.5 11.875 11 12.7812 11ZM16 16.5V15.2188C16 13.4375 14.5625 12 12.7812 12C12.1875 12 11.5625 12.5 10 12.5C8.40625 12.5 7.8125 12 7.1875 12C5.40625 12 4 13.4375 4 15.2188V16.5C4 16.7812 4.21875 17 4.5 17H15.5C15.75 17 16 16.7812 16 16.5ZM10 10C7.78125 10 6 8.21875 6 6C6 3.8125 7.78125 2 10 2C12.1875 2 14 3.8125 14 6C14 8.21875 12.1875 10 10 10ZM10 3C8.34375 3 7 4.375 7 6C7 7.65625 8.34375 9 10 9C11.625 9 13 7.65625 13 6C13 4.375 11.625 3 10 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDdImg1);
export default __webpack_public_path__ + "static/media/profileDDImg1.09b333ad11d5fbd8cdcb64ab2f5929c1.svg";
export { ForwardRef as ReactComponent };